import React, { FormEvent } from 'react';
import { UseFormMethods } from 'react-hook-form';

interface IRHFSelectProps extends Partial<Pick<UseFormMethods, 'register' | 'errors'>> {
    label?: string;
    labelOnLeft?: boolean;
    labelStyle?: React.CSSProperties;
    placeholder?: string;
    name: string;
    options: Array<{ value: string | undefined | number; label: string }>;
    disabled?: boolean;
    rules?: unknown;
    style?: React.CSSProperties;
    defaultVal?: string | number | ReadonlyArray<string>;
    bodyStyle?: React.CSSProperties;
    onChange?: (e: FormEvent<HTMLSelectElement>) => void;
    isRequired?: boolean;
    title?: string;
    id?: string;
    toolTip?: string;
}

const RHFSelect = (props: IRHFSelectProps) => {

    if (props.labelOnLeft) {
        return (
            <div className="form-field" style={props.bodyStyle}>
                { props.label && <div className="form-row">
                <label htmlFor={props.name} style={{...props.labelStyle}}>
                    {props.label}
                    {!!props.isRequired && <span style={{ color: 'red' }}>*</span>}
                </label>
                <select
                    id={!!props?.id ? props.id : props.name}
                    name={props.name}
                    ref={props.register ? props.register(props.rules) : null}
                    style={!!props.disabled ? { cursor: 'not-allowed', ...props.style} : props.style}
                    disabled={props.disabled}
                    onChange={props.onChange}
                    className={`field ${props.name.split('.')?.reduce((o, i) => o?.[i], props.errors) ? 'error-field' : ''}`}
                    defaultValue={props.defaultVal ? props.defaultVal : ''}
                    title={props.title}
                >
                    <option key={0} disabled={true} hidden={true} value="">
                        {props.placeholder || '-- Select --'}
                    </option>
                    {props.options.map((option) => (
                        <option key={`${props.name}-${option.value}`} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                    {props.toolTip && <span className="tooltiptext">{props.toolTip}</span>}
                </select>
                </div>}
                {props.name.split('.')?.reduce((o, i) => o?.[i], props.errors) && (
                    <p style={{color: 'red', marginLeft: '2px'}}>{props.name.split('.')?.reduce((o, i) => o[i], props.errors)?.message}</p>
                )}
            </div>
        );
    } else {
        return (
            <div className="form-field" style={props.bodyStyle}>
                {props.label && <label htmlFor={props.name}>
                    {props.label}
                    {!!props.isRequired && <span style={{ color: 'red' }}>*</span>}
                </label>}
                {props.label && <br />}
                <select
                    id={!!props?.id ? props.id : props.name}
                    name={props.name}
                    ref={props.register ? props.register(props.rules) : null}
                    style={!!props.disabled ? { cursor: 'not-allowed', ...props.style} : props.style}
                    disabled={props.disabled}
                    onChange={props.onChange}
                    className={`field ${props.name.split('.')?.reduce((o, i) => o?.[i], props.errors) ? 'error-field' : ''}`}
                    defaultValue={props.defaultVal ? props.defaultVal : ''}
                    title={props.title}
                >
                    <option key={0} disabled={true} hidden={true} value="">
                        {props.placeholder || '-- Select --'}
                    </option>
                    {props.options.map((option) => (
                        <option key={`${props.name}-${option.value}`} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>
                <br />
                {props.name.split('.')?.reduce((o, i) => o?.[i], props.errors) && (
                    <p>{props.name.split('.')?.reduce((o, i) => o[i], props.errors)?.message}</p>
                )}
            </div>
        );
    }
};

export default RHFSelect;



// WEBPACK FOOTER //
// ./src/components/controls/tempRHFControls/RHFSelect.tsx